/**
 * Gestione Pratiche API
 * Servizi per la gestione della piattaforma Gestione Pratiche
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { GenericResponseDTO } from '../model/genericResponseDTO';
import { IdPeriodoAccettaBody } from '../model/idPeriodoAccettaBody';
import { InlineResponse500 } from '../model/inlineResponse500';
import { PeriodoRendicontazione } from '../model/periodoRendicontazione';
import { PeriodoRendicontazioneCedoleStatsDTO } from '../model/periodoRendicontazioneCedoleStatsDTO';
import { RendicontazioneEsercenteDTO } from '../model/rendicontazioneEsercenteDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RendicontazioniControllerService {

    protected basePath = 'http://comune.southengineering.it/gestione-pratiche';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Consente di accettare una rendicontazione di un esercente per un determinato periodo.
     * @param id_slug_comune 
     * @param idEsercente 
     * @param idPeriodo 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public accettaRendicontazioneEsercentePerPeriodo(id_slug_comune: string, idEsercente: string, idPeriodo: string, body?: IdPeriodoAccettaBody, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public accettaRendicontazioneEsercentePerPeriodo(id_slug_comune: string, idEsercente: string, idPeriodo: string, body?: IdPeriodoAccettaBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public accettaRendicontazioneEsercentePerPeriodo(id_slug_comune: string, idEsercente: string, idPeriodo: string, body?: IdPeriodoAccettaBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public accettaRendicontazioneEsercentePerPeriodo(id_slug_comune: string, idEsercente: string, idPeriodo: string, body?: IdPeriodoAccettaBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling accettaRendicontazioneEsercentePerPeriodo.');
        }

        if (idEsercente === null || idEsercente === undefined) {
            throw new Error('Required parameter idEsercente was null or undefined when calling accettaRendicontazioneEsercentePerPeriodo.');
        }

        if (idPeriodo === null || idPeriodo === undefined) {
            throw new Error('Required parameter idPeriodo was null or undefined when calling accettaRendicontazioneEsercentePerPeriodo.');
        }


        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/rendicontazioni/esercente/${encodeURIComponent(String(idEsercente))}/periodo/${encodeURIComponent(String(idPeriodo))}/accetta`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di scaricare il file relativo alla rendicontazione esercente
     * @param id_slug_comune 
     * @param codicePratica 
     * @param idPeriodo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadFileRendicontazioneEsercente(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public downloadFileRendicontazioneEsercente(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public downloadFileRendicontazioneEsercente(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public downloadFileRendicontazioneEsercente(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling downloadFileRendicontazioneEsercente.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling downloadFileRendicontazioneEsercente.');
        }

        if (idPeriodo === null || idPeriodo === undefined) {
            throw new Error('Required parameter idPeriodo was null or undefined when calling downloadFileRendicontazioneEsercente.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/rendicontazioni/esercente/${encodeURIComponent(String(codicePratica))}/periodo/${encodeURIComponent(String(idPeriodo))}/rendicontazione_esercente`,
            {
             responseType: "blob" as "json",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di scaricare il file relativo alla rendicontazione esercente controfirmata
     * @param id_slug_comune 
     * @param codicePratica 
     * @param idPeriodo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadFileRendicontazioneEsercenteControfirmata(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public downloadFileRendicontazioneEsercenteControfirmata(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public downloadFileRendicontazioneEsercenteControfirmata(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public downloadFileRendicontazioneEsercenteControfirmata(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling downloadFileRendicontazioneEsercenteControfirmata.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling downloadFileRendicontazioneEsercenteControfirmata.');
        }

        if (idPeriodo === null || idPeriodo === undefined) {
            throw new Error('Required parameter idPeriodo was null or undefined when calling downloadFileRendicontazioneEsercenteControfirmata.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/rendicontazioni/esercente/${encodeURIComponent(String(codicePratica))}/periodo/${encodeURIComponent(String(idPeriodo))}/rendicontazione_esercente_controfirmata`,
            {
             responseType: "blob" as "json",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di ottenere i dati della rendicontazione di un esercente per un determinato periodo.
     * @param id_slug_comune 
     * @param codicePratica 
     * @param idPeriodo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadPdfRendicontazioneEsercentePerPeriodo(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public downloadPdfRendicontazioneEsercentePerPeriodo(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public downloadPdfRendicontazioneEsercentePerPeriodo(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public downloadPdfRendicontazioneEsercentePerPeriodo(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling downloadPdfRendicontazioneEsercentePerPeriodo.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling downloadPdfRendicontazioneEsercentePerPeriodo.');
        }

        if (idPeriodo === null || idPeriodo === undefined) {
            throw new Error('Required parameter idPeriodo was null or undefined when calling downloadPdfRendicontazioneEsercentePerPeriodo.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/rendicontazioni/esercente/${encodeURIComponent(String(codicePratica))}/periodo/${encodeURIComponent(String(idPeriodo))}/pdf_rendicontazione_esercente`,
            {
             responseType: "blob" as "json",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di ottenere i periodi di rendicontazione abilitati o in attesa di essere abilitati
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPeriodiRendicontazione(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<Array<PeriodoRendicontazione>>;
    public getPeriodiRendicontazione(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PeriodoRendicontazione>>>;
    public getPeriodiRendicontazione(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PeriodoRendicontazione>>>;
    public getPeriodiRendicontazione(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getPeriodiRendicontazione.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<PeriodoRendicontazione>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/rendicontazioni/periodiRendicontazione`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di ottenere i dati della rendicontazione di un esercente per un determinato periodo.
     * @param id_slug_comune 
     * @param codicePratica 
     * @param idPeriodo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRendicontazioneEsercentePerPeriodo(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe?: 'body', reportProgress?: boolean): Observable<RendicontazioneEsercenteDTO>;
    public getRendicontazioneEsercentePerPeriodo(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RendicontazioneEsercenteDTO>>;
    public getRendicontazioneEsercentePerPeriodo(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RendicontazioneEsercenteDTO>>;
    public getRendicontazioneEsercentePerPeriodo(id_slug_comune: string, codicePratica: string, idPeriodo: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getRendicontazioneEsercentePerPeriodo.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling getRendicontazioneEsercentePerPeriodo.');
        }

        if (idPeriodo === null || idPeriodo === undefined) {
            throw new Error('Required parameter idPeriodo was null or undefined when calling getRendicontazioneEsercentePerPeriodo.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RendicontazioneEsercenteDTO>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/rendicontazioni/esercente/${encodeURIComponent(String(codicePratica))}/periodo/${encodeURIComponent(String(idPeriodo))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di ottenere le statistiche dati della rendicontazione di un esercente per un determinato periodo.
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStatsCedoleRendicontazioneEsercente(id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Array<PeriodoRendicontazioneCedoleStatsDTO>>;
    public getStatsCedoleRendicontazioneEsercente(id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PeriodoRendicontazioneCedoleStatsDTO>>>;
    public getStatsCedoleRendicontazioneEsercente(id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PeriodoRendicontazioneCedoleStatsDTO>>>;
    public getStatsCedoleRendicontazioneEsercente(id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getStatsCedoleRendicontazioneEsercente.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling getStatsCedoleRendicontazioneEsercente.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<PeriodoRendicontazioneCedoleStatsDTO>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/rendicontazioni/esercente/${encodeURIComponent(String(codicePratica))}/stats`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di definire come pagata una rendicontazione di un esercente per un determinato periodo.
     * @param id_slug_comune 
     * @param idEsercente 
     * @param idPeriodo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pagataRendicontazioneEsercentePerPeriodo(id_slug_comune: string, idEsercente: string, idPeriodo: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public pagataRendicontazioneEsercentePerPeriodo(id_slug_comune: string, idEsercente: string, idPeriodo: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public pagataRendicontazioneEsercentePerPeriodo(id_slug_comune: string, idEsercente: string, idPeriodo: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public pagataRendicontazioneEsercentePerPeriodo(id_slug_comune: string, idEsercente: string, idPeriodo: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling pagataRendicontazioneEsercentePerPeriodo.');
        }

        if (idEsercente === null || idEsercente === undefined) {
            throw new Error('Required parameter idEsercente was null or undefined when calling pagataRendicontazioneEsercentePerPeriodo.');
        }

        if (idPeriodo === null || idPeriodo === undefined) {
            throw new Error('Required parameter idPeriodo was null or undefined when calling pagataRendicontazioneEsercentePerPeriodo.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/rendicontazioni/esercente/${encodeURIComponent(String(idEsercente))}/periodo/${encodeURIComponent(String(idPeriodo))}/pagata`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di rifiutare una rendicontazione di un esercente per un determinato periodo.
     * @param id_slug_comune 
     * @param idEsercente 
     * @param idPeriodo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rifiutaRendicontazioneEsercentePerPeriodo(id_slug_comune: string, idEsercente: string, idPeriodo: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public rifiutaRendicontazioneEsercentePerPeriodo(id_slug_comune: string, idEsercente: string, idPeriodo: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public rifiutaRendicontazioneEsercentePerPeriodo(id_slug_comune: string, idEsercente: string, idPeriodo: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public rifiutaRendicontazioneEsercentePerPeriodo(id_slug_comune: string, idEsercente: string, idPeriodo: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling rifiutaRendicontazioneEsercentePerPeriodo.');
        }

        if (idEsercente === null || idEsercente === undefined) {
            throw new Error('Required parameter idEsercente was null or undefined when calling rifiutaRendicontazioneEsercentePerPeriodo.');
        }

        if (idPeriodo === null || idPeriodo === undefined) {
            throw new Error('Required parameter idPeriodo was null or undefined when calling rifiutaRendicontazioneEsercentePerPeriodo.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/rendicontazioni/esercente/${encodeURIComponent(String(idEsercente))}/periodo/${encodeURIComponent(String(idPeriodo))}/rifiuta`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di sottomettere una rendicontazione di un esercente per un determinato periodo.
     * @param id_slug_comune 
     * @param codicePratica 
     * @param idPeriodo 
     * @param rendicontazione 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sottomettiRendicontazioneEsercentePerPeriodoForm(id_slug_comune: string, codicePratica: string, idPeriodo: string, rendicontazione?: Blob, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public sottomettiRendicontazioneEsercentePerPeriodoForm(id_slug_comune: string, codicePratica: string, idPeriodo: string, rendicontazione?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public sottomettiRendicontazioneEsercentePerPeriodoForm(id_slug_comune: string, codicePratica: string, idPeriodo: string, rendicontazione?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public sottomettiRendicontazioneEsercentePerPeriodoForm(id_slug_comune: string, codicePratica: string, idPeriodo: string, rendicontazione?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling sottomettiRendicontazioneEsercentePerPeriodo.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling sottomettiRendicontazioneEsercentePerPeriodo.');
        }

        if (idPeriodo === null || idPeriodo === undefined) {
            throw new Error('Required parameter idPeriodo was null or undefined when calling sottomettiRendicontazioneEsercentePerPeriodo.');
        }


        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = canConsumeForm;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (rendicontazione !== undefined) {
            formParams = formParams.append('rendicontazione', <any>rendicontazione) as any || formParams;
        }

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/rendicontazioni/esercente/${encodeURIComponent(String(codicePratica))}/periodo/${encodeURIComponent(String(idPeriodo))}/sottometti`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
